import { useEffect } from 'react';

import { useAuth } from '@sine/auth-client';

export default function Pendo() {
  const { authState, userDetails } = useAuth();

  useEffect(() => {
    if (authState === 'loggedIn' && window.env.PENDO_CLIENT_KEY && userDetails)
      pendo.initialize({
        visitor: {
          id: userDetails.id,
          email: userDetails.email,
          first_name: userDetails.firstName,
          last_name: userDetails.lastName,
          company: userDetails.company,
          isTeamOwner: userDetails.isTeamOwner,
          permissions: userDetails.permissions,
          teams: userDetails.teams,
        },
      });
  }, [authState, userDetails]);

  return null;
}
